import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Alert, Typography} from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

const getIcon = (severity) => {
  switch (severity) {
    case 'success':
      return <CheckCircleOutlineIcon color="success" sx={{ mr: 1 }} />;
    case 'error':
      return <ErrorOutlineIcon color="error" sx={{ mr: 1 }} />;
    case 'warning':
      return <WarningAmberOutlinedIcon color="warning" sx={{ mr: 1 }} />;
    default:
      return <InfoOutlinedIcon color="info" sx={{ mr: 1 }} />;
  }
};

const ModalResult = ({ open, onClose, message, severity = 'info', title }) => {
  return (
    <Dialog
      open={open}
      onClose={() => {}}
      disableEscapeKeyDown
      disableBackdropClick
      aria-labelledby="modal-result-title"
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 2,
          minWidth: 340,
          maxWidth: 420,
        },
      }}
    >
      {title && (
        <DialogTitle id="modal-result-title" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', pb: 2 }}>
          {getIcon(severity)}
          <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </DialogTitle>
      )}
      <DialogContent sx={{ pt: title ? 1 : 3, pb: 2, textAlign: 'center' }}>
        <Alert severity={severity} sx={{ borderRadius: 2, fontSize: 16, justifyContent: 'center' }}>{message}</Alert>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
        <Button onClick={onClose} variant="contained" color={severity === 'error' ? 'error' : 'primary'} size="large" sx={{ borderRadius: 2, px: 4, fontWeight: 600 }} autoFocus>
          Chiudi
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalResult; 